import React from 'react';
import { Card } from 'react-bootstrap';
import { ProgressIndicator } from './ProgressIndicator';
import {
  GetIndividualCounts,
  GetFamilyCounts,
} from '../../../../../Member/utils/Coverage';
import Skeleton from './skeleton/GenericSkeleton';
import { useSelector } from 'react-redux';

export const NetworkCard = ({
  label,
  PlanDetails,
  CurrentActive,
  dataFetching,
  selectedUser,
  isFamilySelected,
  networkLabel,
  networkPlandetails,
  showDedLabel = false,
  showOopLabel = false,
}) => {
  const { Value_Network_For_Coverage_Admin } =
    useSelector((state) => state.app.appConfigs.Network_Setting) || 'network';
  const countsInformation = isFamilySelected
    ? GetFamilyCounts(label, PlanDetails)
    : GetIndividualCounts(label, PlanDetails);
  let accumsLabel = '';
  if (label === 'In-network Summary') {
    if (networkLabel) {
      if (networkLabel !== 'ALL') {
        accumsLabel = networkLabel;
      } else {
        accumsLabel = 'In-network';
      }
    } else {
      accumsLabel = 'In-network';
    }
  }
  if (label === 'Out-of-network Summary') {
    if (Value_Network_For_Coverage_Admin === 'tier') {
      let networkTier = '';
      networkPlandetails &&
        networkPlandetails.map((data) => {
          if (data.BenefitScheduleType === 'Out-Of-Area') {
            networkTier = data.NetworkTier;
          }
        });
      if (networkTier) {
        accumsLabel = networkTier;
      } else {
        accumsLabel = 'Out-of-network';
      }
    } else {
      accumsLabel = 'Out-of-network';
    }
  }
  if (label === 'Penalty Summary') {
    if (Value_Network_For_Coverage_Admin === 'tier') {
      let networkTier = '';
      networkPlandetails &&
        networkPlandetails.map((data) => {
          if (data.BenefitScheduleType === 'Penalty') {
            networkTier = data.NetworkTier;
          }
        });
      if (networkTier) {
        accumsLabel = networkTier;
      } else {
        accumsLabel = 'Out-of-network Penalty';
      }
    } else {
      accumsLabel = 'Out-of-network Penalty';
    }
  }
  return (
    <>
      {dataFetching ? (
        <Skeleton />
      ) : (
        <Card>
          <div className="mb-4">
            <p className="text-center network-label">{accumsLabel}</p>
          </div>
          <div className="mb-3">
            <ProgressIndicator
              label="Deductible"
              max={countsInformation?.deductable?.deductableMax}
              applied={countsInformation?.deductable?.appliedAmount}
              Value_Network_For_Coverage_Admin={
                Value_Network_For_Coverage_Admin
              }
              showCustomLabel={isFamilySelected ? false : showDedLabel}
              msg="See Family Deductible"
            />
          </div>
          <div className="mt-3">
            <ProgressIndicator
              label="Out-of-pocket"
              max={countsInformation?.outOfPocket?.outOfPocketMax}
              applied={countsInformation?.outOfPocket?.appliedAmount}
              Value_Network_For_Coverage_Admin={
                Value_Network_For_Coverage_Admin
              }
              showCustomLabel={isFamilySelected ? false : showOopLabel}
              msg="See Family Out of Pocket"
            />
          </div>
        </Card>
      )}
    </>
  );
};
